import React, { Component } from 'react';
import { Button, Form, Grid } from 'semantic-ui-react'
import { resetPassword, checkResetPassword } from '../utils/rest';
import { isExternalTokenExpired } from '../utils/auth';
import * as SimpleReactValidator from 'simple-react-validator';
import { withRouter } from 'react-router-dom';
class ResetPassword extends Component {

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator({
            confirm: { // name the rule
                message: 'The :attribute should not matched', // give a message that will display when there is an error. :attribute will be replaced by the name you supply in calling it.
                rule: function (val, options) { // return true if it is succeeds and false it if fails validation. 
                    return options.length > 0 ? val === options[0] : false;
                }
            }
        });
        this.state = {
            newPassword: "",
            confirmPassword: ""
        }
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    componentDidMount = () => {
        if (!this.props.match.params.token || this.props.match.params.token.length === 0) {
            this.props.logout();
        } else {
            if (!isExternalTokenExpired(this.props.match.params.token)) {
                checkResetPassword({
                    token: this.props.match.params.token
                }).then(response => {
                    if (response === null) {
                        this.props.history.push("/?r=expired");
                    }
                });
            } else {
                this.props.history.push("/?r=texpired");
            }
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            const { newPassword, confirmPassword } = this.state;
            if (newPassword.length > 0 && confirmPassword.length > 0) {
                resetPassword({
                    usrPassword: newPassword
                }, {
                        token: this.props.match.params.token
                    }).then(response => {
                        if (response !== null) {
                            this.props.history.push("/?r=login");
                        }
                    });
            }
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.forceUpdate();
        }

    }
    render() {
        return (
            <div className="login-form">
                <style>{`
                    body, html { height: 100% !important;background-color:black}
      body > div,
      body > div > div,
      body > div > div > div.login-form {
        height: 100% !important;
      }
    `}</style>
                <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
                    <Grid.Column style={{ maxWidth: 450 }}>
                        <Form size='large'>
                            <Form.Field>
                                <Form.Input
                                    fluid
                                    icon='lock'
                                    name="newPassword"
                                    iconPosition='left'
                                    placeholder={this.props.t("new.password")}
                                    type='password'
                                    value={this.state.newPassword}
                                    onChange={this.onChange}
                                />
                                {this.validator.message(this.props.t("new.password"), this.state.newPassword, 'required|min:8')}
                            </Form.Field>
                            <Form.Field>
                                <Form.Input
                                    fluid
                                    icon='lock'
                                    iconPosition='left'
                                    placeholder={this.props.t("confirm.password")}
                                    type='password'
                                    name="confirmPassword"
                                    value={this.state.confirmPassword}
                                    onChange={this.onChange}
                                />
                                {this.validator.message(this.props.t("confirm.password"), this.state.confirmPassword, 'required|confirm:' + this.state.newPassword)}
                            </Form.Field>
                            <Button disabled={this.state.newPassword.length > 0 ? false : true} className="fluid blue" size='large' onClick={this.handleSubmit}>
                                {this.props.t("reset.password")}
                            </Button>
                        </Form>
                    </Grid.Column>
                </Grid>
            </div>
        )
    }
}
export default (withRouter(ResetPassword));


// WEBPACK FOOTER //
// ./src/app/login/ResetPassword.js